<div class="search-bar" role="search">
  <input
    #searchInput
    type="search"
    class="search-input"
    [value]="inputValue"
    [placeholder]="placeholder"
    [attr.aria-label]="placeholder"
    (input)="onInputChange(searchInput.value)"
    (focus)="onInputFocus()"
    (blur)="onInputBlur()"
    (keydown)="onInputKeydown($event)"
  />

  <div
    class="autocomplete-panel"
    *ngIf="showSuggestions"
    [style.left.px]="dropdownLeft"
    [style.top.px]="dropdownTop"
    [style.width.px]="dropdownWidth"
  >
    <ng-container *ngIf="useResultDropdown; else suggestionList">
      <button
        *ngFor="let quickResult of filteredResults; let i = index"
        #suggestionItem
        type="button"
        class="autocomplete-item autocomplete-item--result"
        [class.is-highlighted]="highlightedIndex === i"
        (mousedown)="onResultMouseDown($event, quickResult)"
      >
        <span class="autocomplete-primary">{{ quickResult.label | capitalize }}</span>
      </button>
    </ng-container>
    <ng-template #suggestionList>
      <button
        *ngFor="let suggestion of filteredSuggestions; trackBy: trackSuggestion; let i = index"
        #suggestionItem
        type="button"
        class="autocomplete-item"
        [class.is-highlighted]="highlightedIndex === i"
        (mousedown)="onSuggestionMouseDown($event, suggestion)"
      >
        <span class="autocomplete-primary">... {{ suggestion.label | lowercase }}</span>
        <span class="autocomplete-type" [attr.data-type]="suggestion.type" *ngIf="suggestion.type !== 'term'">
          {{ suggestion.type === 'county' ? countyLabel : cityLabel }}
        </span>
      </button>
    </ng-template>
  </div>
</div>
